import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';

import { ConsumerMoneyOrderHandlerProvider } from '../../providers/consumer-money-order-handler';
import { BaseListPage } from '../../providers/base-list-page';

import { ConsumerMoneyOrderDetailPage } from '../../pages/consumer-money-order-detail/consumer-money-order-detail';

@Component({
  selector: 'consumer-money-order-list',
  templateUrl: 'consumer-money-order-list.html'
})
export class ConsumerMoneyOrderListComponent extends BaseListPage {
	@Input('business') business;

	constructor(
		public navCtrl: NavController, 
		public mainProvider: ConsumerMoneyOrderHandlerProvider, 	
	) {
		super();
	}

	ngOnInit(){
		this.mainProvider.getOrders({
			businessId: this.business.Id, 
			page: 1, 
			size: 20, 
		});
	}	

	gotoDetail(order){
		this.mainProvider.order = order;

		this.navCtrl.push(ConsumerMoneyOrderDetailPage, {});		
	}	
}



// WEBPACK FOOTER //
// ./src/components/consumer-money-order-list/consumer-money-order-list.ts